import React from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'

import { ContentsProps } from './FairDetail.types'
import { ImageComponent } from '../../components/ui-elements/Image'

const Component: React.FC<ContentsProps> = (props) => {
  const { fairContents } = props
  return (
    <div className={props.className}>
      {fairContents.map((content, index) => {
        const isShortDescription = content.descriptionText.length < 125
        return (
          <div className={`content-card ${isShortDescription ? 'short-description' : ''}`} key={index}>
            {content.imageData && (
              <div className="main-image-wrapper">
                <ImageComponent
                  imageData={content.imageData}
                  aspectRatio={'threeToTwoImage'}
                  altText={content.name}
                  className="main-image"
                />
              </div>
            )}
            <div className="detail-wrapper">
              <div className="name">{content.name}</div>
              <pre className="description-text">{content.descriptionText}</pre>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export const FairContents: React.FC<ContentsProps> = styled(Component)`
  > .content-card {
    margin-bottom: 16px;
    border: 2px solid ${styleTheme.colors.gray.light};
    border-radius: 8px;
    display: grid;
    grid-template-columns: 300px 1fr;
    align-items: start;

    > .main-image-wrapper {
      width: 100%;
      position: relative;
      padding-top: 66.66%;
      overflow: hidden;

      > .main-image {
        width: 300px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 0;
      }
    }

    &.short-description {
      > .main-image-wrapper > .main-image {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;

        @media (max-width: 768px) {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }

    > .detail-wrapper {
      padding: 32px;

      > .name {
        color: ${styleTheme.colors.black};
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        border-bottom: 2px solid ${styleTheme.colors.gray.light};
        margin-bottom: 16px;
        padding-bottom: 8px;
      }

      > .description-text {
        color: ${styleTheme.colors.black};
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 180%;
        white-space: pre-wrap;
      }
    }
  }

  @media (max-width: 768px) {
    > .content-card {
      margin-bottom: 12px;
      height: auto;
      grid-template-columns: 1fr;

      > .main-image-wrapper {
        width: 100%;
        padding-top: 66.66%;
        position: relative;

        > .main-image {
          width: 100%;
          height: 100%;
          max-height: none;
          position: absolute;
          top: 0;
          left: 0;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }

      > .detail-wrapper {
        padding: 16px;

        > .name {
          font-size: 16px;
          margin-bottom: 8px;
        }
      }
    }
  }
`
